<!--
 * @Description: 绑定医院弹框组件
 * @Author: sunhuihong
 * @Date: 2023-02-07 16:43:52
 * @LastEditTime: 2023-12-19 14:46:51
-->
<template>
  <div class="body">
    <el-dialog width="1200px" title="绑定医院" :visible.sync="visible"
      :close-on-click-modal="false" @open="initData" :before-close="handleCancel" center >
      <div v-if="bindingHospitalData.name" style="margin: 0 25px;">
        <div class="binging-hospital-content">
          <div class="hservice-name">{{bindingHospitalData.name}}</div>
          <div class="hservice-price">服务价格:  {{bindingHospitalData.price + '元起'}}</div>
          <div class="head">
		        <div class="blue-line"></div>
		        <span class="title">绑定医院</span>
            <el-checkbox v-if="bindingHospitalData.hospitalList.length"
              v-model="checked" @change="handleSelectAll">
              全选
            </el-checkbox>
		      </div>
          <el-row :gutter="55" type="flex" style="padding: 0 15px; flex-wrap: wrap;" 
            v-if="bindingHospitalData.hospitalList.length">
            <el-col :span="6" v-for="(item, index) in bindingHospitalData.hospitalList" :key="index" 
              style="margin-top: 25px; position: relative;">
              <div @click="handleHspItem(item)">
                <div :class="item.selectFlag == 1 ? 'binding-hospital-style' : 
                  item.selectFlag == 0 ? 'no-biding-hospital-style' : ''">
                  <img class="binding-hospital-hspLogo" alt="" :src="loadHspLogo(item.logoPath)" />
                  <span class="binding-hospital-name">{{item.name}}</span>
                </div>
                <img class="check-img" :src="item.selectFlag == 1 ?  checkImg
                  : item.selectFlag == 0 ? noCheckImg : ''"  alt="" />
                <img v-if="item.status == 0" class="disabled-img" 
                  src="@/assets/common/icon-common-disabled.png" alt="">
              </div>
            </el-col>
          </el-row>
          <el-empty v-else :image-size="100" description="暂无医院"></el-empty>
        </div>
        <div class="dialog-footer bk-wizard-bottons" v-if="bindingHospitalData.hospitalList.length">
          <el-button @click="handleCancel">取 消</el-button>
          <el-button type="primary" @click="handleSubmit">确 定</el-button>
        </div>
      </div>
      <div  v-else class="binging-hospital-empty">
        <el-empty :image-size="200" description="暂无医院"></el-empty>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";
export default {
  name: 'BindingHospital',
  props: ["visible", "hsvcId"],

  data() {
    return {
      checked: false,
      bindingHospitalData: {},
      checkImg: require("@/assets/common/icon-common-check.png"),
      noCheckImg: require("@/assets/common/icon-common-not-check.png"),
    }
  },

  computed: {
    loadHspLogo() {
      return (logoPath) => {
        return logoPath ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, logoPath)
          : require("@/assets/hsvcmng/img-hsvcmng-default-hospital.png");
      };
    },
  },
  
  methods: {
    initData() {
      let params = {hserviceId: this.hsvcId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_HSERVICE_DO4BINDING_HOSPITAL,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
			this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.bindingHospitalData = result.data || {};
        this.queryCheckedStatus(result.data.hospitalList);
			})
    },

    handleHspItem(item) {
      if (item.selectFlag == 0) {
        item.selectFlag = 1;
      } else if (item.selectFlag == 1) {
        item.selectFlag = 0;
      }
      this.queryCheckedStatus(this.bindingHospitalData.hospitalList);
    },

    //查询当前checkbox状态
    queryCheckedStatus(hospitalList) {
      if (hospitalList.length == 0) {
        this.checked = false;
        return;
      }
      if (hospitalList.findIndex(target => target.selectFlag === 0) == -1) {
        this.checked = true;
      } else {
        this.checked = false;
      }    
    },

    //全选
    handleSelectAll() {
      this.bindingHospitalData.hospitalList.forEach((item) => {
        if (this.checked) {
          item.selectFlag = 1;
        } else {
          item.selectFlag = 0;
        }
			});
    },

    //取消
    handleCancel() {
      this.$emit("close-dialog", false);
    },

    //确定
    handleSubmit() {
      let header = this.encryptionUtil.signatureBody(this.bindingHospitalData,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'POST',
        url: Constant.URL_SAVE_OR_UPDATE_HSERVICE_HOSPITAL,
        param: this.bindingHospitalData,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.$emit("close-dialog", true);
			})
    }
  },
}
</script>

<style scoped>
.binging-hospital-content {
  margin-bottom: 60px;
}

.binging-hospital-content .hservice-name {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  line-height: 20px;
}

.binging-hospital-content .hservice-price {
  font-size: 13px;
  font-weight: 400;
  color: #525254;
  line-height: 18px;
  margin: 8px 0 27px 0;
}

.binging-hospital-content .head {
  height: 20px;
  line-height: 20px;
  display: flex;
  align-items: center;
}

.binging-hospital-content .head .blue-line {
  width: 4px;
  height: 14px;
  background: #3E7EF5;
  border-radius: 2px;
}

.binging-hospital-content .head .title {
  font-size: 14px;
  font-weight: 600;
  color: #657180;
  margin: 0 20px 0 11px ;
}

.binding-hospital-style {
  height: 95px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #3E7EF5;
  padding: 0 22px 0 10px;
  color: #3E7EF5;
  cursor: pointer;
}

.no-biding-hospital-style {
  height: 95px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #C4CBD4;
  padding: 0 22px 0 10px;
  color: #000000;
  cursor: pointer;
}

.binding-hospital-hspLogo {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
}

.binding-hospital-name {
  overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;   
}

.check-img {
  position: absolute;
  width: 35px;
  height: 36px;
  bottom: 0;
  right: 0;
  margin-right: 28px;
  cursor: pointer;
}

.disabled-img {
  position: absolute;
  width: 33px;
  height: 16px;
  top: 0;
  left: 0;
  margin-left: 19px;
}

.dialog-footer {
  text-align: center;
}

.binging-hospital-empty {
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style>
.binging-hospital-content .head .el-checkbox__label {
  color: #3E7EF5 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/hsvcmng/components/BindingHospital.vue